import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortDesc = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 18,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0 C3.875 1.75 3.875 1.75 5 4 C4.01 4 3.02 4 2 4 C2 8.62 2 13.24 2 18 C1.34 18 0.68 18 0 18 C0 13.38 0 8.76 0 4 C-0.99 3.67 -1.98 3.34 -3 3 C-2.01 2.01 -1.02 1.02 0 0 Z ",
			fill: "currentColor",
			transform: "translate(15,0)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0 C3.3 0 6.6 0 10 0 C10 0.66 10 1.32 10 2 C6.7 2 3.4 2 0 2 C0 1.34 0 0.68 0 0 Z ",
			fill: "currentColor",
			transform: "translate(0,14)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C4.69 2 2.38 2 0 2 C0 1.34 0 0.68 0 0 Z ",
			fill: "currentColor",
			transform: "translate(0,8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z ",
			fill: "currentColor",
			transform: "translate(0,2)"
		})
	]
});
export default SvgSortDesc;
